/** Three drawn poses played contact → passing → opposite contact → passing. */
export const STEP_POSES = [1, 2, 3, 2] as const

/** Advance once per simulation tick from actual horizontal travel.
 * At most one pose per four ticks avoids flicker after large corrections.
 * Airborne actors hold phase; stopped grounded actors return to neutral.
 */
export function advanceWalkPhase(
  phase: number,
  distance: number,
  grounded: boolean,
  pixelsPerPose = 8,
): number {
  if (!grounded) return phase
  const travel = Math.abs(distance)
  if (travel < 0.01) return 0
  return (phase + Math.min(0.25, travel / pixelsPerPose)) % STEP_POSES.length
}

export function stepPose(phase: number): number {
  const index = Math.floor(Math.abs(Number.isFinite(phase) ? phase : 0))
  return STEP_POSES[index % STEP_POSES.length] ?? 1
}
